require("./navigation");
require("./search");
require("./svgxuse");
require("./gallery");

$(function () {

	$(".sitenav__link:not(.secondary-nav)").each(function (index) {
		$(this).attr("nav-index", index);
		$(this).clone().removeClass("sitenav__link").addClass("dropdown__link").appendTo(".secondary-nav .dropdown__links").find(".dropdown").remove();
	})


	$(".subnav__link:not(.subnav__link--secondary)").each(function (index) {
		$(this).attr("nav-index", index);
		$(this).clone().appendTo($(this).closest(".subnav").find(".subnav__link--secondary .subnav__dropdown"));
	})

	var openDropdowns = $(".sitenav__links .dropdown.is-open")
	if (openDropdowns.length > 0) {
		if (openDropdowns.length > 1) {
			$(".sitenav__links").scrollTop($(openDropdowns[1]).parent().offset().top - 200);
		}
		else {
			$(".sitenav__links").scrollTop($(openDropdowns[0]).parent().offset().top - 200);
		}
	}

	recalculateWidths();
	hideOverflowingLinks();
});


$(window).resize(function () {
	recalculateWidths();
	hideOverflowingLinks();
});

function recalculateWidths() {
	$(".sitenav__link, .subnav__link").each(function () {
		$(this).attr("nav-width", $(this).outerWidth());
	});
}

function hideOverflowingLinks() {
	console.log("hideOverflowingLinks");
	var secondaryNav = $(".secondary-nav");
	var width = $(".sitenav__links").width();
	var secondaryWidth = secondaryNav.outerWidth() * 2;
	var currentWidth = 0;
	$(".sitenav__link:not(.secondary-nav)").each(function () {
		currentWidth = currentWidth + $(this).outerWidth();
		console.log({ currentWidth, width, secondaryWidth })
		if (currentWidth > (width - secondaryWidth)) {
			$(this).addClass("sitenav__link--hidden");
			secondaryNav.find(".dropdown__link[nav-index=" + $(this).attr("nav-index") + "]").removeClass("dropdown__link--hidden");
		}
		else {
			$(this).removeClass("sitenav__link--hidden");
			secondaryNav.find(".dropdown__link[nav-index=" + $(this).attr("nav-index") + "]").addClass("dropdown__link--hidden");
		}
	})

	if ($(".secondary-nav .dropdown__link:not(.dropdown__link--hidden)").length > 0) {
		$(".secondary-nav").removeClass("sitenav__link--hidden");
	}
	else {
		$(".secondary-nav").addClass("sitenav__link--hidden");
	}
}
